import { Divider, Stack, Typography } from '@mui/material';
import { PriceSuggestionType } from '@retail/products/types';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PrioritizedPriceType } from './PrioritizedPriceType';

interface Props {
  selectedPriceSuggestionTypes: PriceSuggestionType[];
  getPriceTypeValue: (priceType: PriceSuggestionType) => string;
  handleReprioritizedPriceSuggestions: (priceTypeIndex: number, prioritize: 'UP' | 'DOWN') => void;
  checkPriceType: (priceType: PriceSuggestionType) => void;
}

export function PriceSuggestionPriority({
  selectedPriceSuggestionTypes,
  getPriceTypeValue,
  handleReprioritizedPriceSuggestions,
  checkPriceType,
}: Props) {
  const t = usePriceSuggestionTFunction();
  return (
    <Stack flexGrow={1}>
      <Stack height={50} width="100%" justifyContent="center" bgcolor="grey.50">
        <Typography pl={3}>{t('priceSuggestion.prioritizedPriceSuggestions')}</Typography>
      </Stack>
      <Stack>
        {selectedPriceSuggestionTypes.map((priceType, index) => (
          <Stack key={priceType}>
            <PrioritizedPriceType
              priceType={priceType}
              priority={index + 1}
              totalPrioritySuggestions={selectedPriceSuggestionTypes.length}
              checkPriceType={checkPriceType}
              handleReprioritizedPriceSuggestions={handleReprioritizedPriceSuggestions}
              getPriceTypeValue={getPriceTypeValue}
            />
            {index !== selectedPriceSuggestionTypes.length - 1 && <Divider variant="middle" />}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
